








import VueOptions from '@utils/VueOptions'

settings =
  name: 'CampaignEdit'
  resources:
    campaign: 
      resourceName: "campaign"
      slug: "campaigns/:campaignId/edit"
  vue:
    props: ['campaignId']
    methods:
      onSave: (item) -> @$router.push({ name: 'CampaignShowPage', params: { campaignId: item.id } })

export default VueOptions.vue settings
